import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { updateScenario, choiceSelector, scenariosCompletedCount } from '../../services/store';
import './style.css';

const mapStateToProps = (state, ownProps) => ({
  choice: choiceSelector(ownProps.id)(state),
  completedCount: scenariosCompletedCount(state),
});

class Scenario extends Component {
  isActive = () => {
    return this.props.completedCount + 1 >= Number(this.props.id);
  }

  handleFirst = () => {
    const { onCallback } = this.props;

    this.props.updateScenario({
      id: this.props.id,
      score: this.props.scoreFirst,
      choice: 'first',
    });

    if (onCallback) {
      onCallback(this.props.title, this.props.buttonTextFirst);
    }
  }

  handleSecond = () => {
    const { onCallback } = this.props;

    this.props.updateScenario({
      id: this.props.id,
      score: this.props.scoreSecond,
      choice: 'second',
    });

    if (onCallback) {
      onCallback(this.props.title, this.props.buttonTextSecond);
    }
  }

  btnClass = (btn) => {
    const { choice } = this.props;

    return cx('scenario__btn', {
      'scenario__btn--active': choice === btn,
      'scenario__btn--disabled': choice && choice !== btn
    });
  }

  render() {
    const {
      choice,
      title,
      description,
      buttonTextFirst,
      buttonTextSecond,
      resultTextFirst,
      resultTextSecond,
      scoreFirst,
      scoreSecond,
    } = this.props;

    if (!this.isActive()) {
      return (
        <div className="scenario scenario--placeholder">
          <div className="scenario__content scenario__content--placeholder">
            <p className="scenario__description">Vul eerst de vragen hierboven in. De uitkomst daarvan bepaalt het wat jij te zien krijgt.</p>
          </div>
        </div>
      )
    }

    return (
      <div className="scenario">
        <div className="scenario__content">
          <div className="scenario__text">
            {title && <h3 className="scenario__title">{title}</h3>}
            <p className="scenario__description">{description}</p>
          </div>

          <div className="scenario__actions">
            {buttonTextFirst && (
              <button
                className={this.btnClass('first')}
                disabled={choice !== undefined}
                onClick={this.handleFirst}
              >
                {buttonTextFirst}
              </button>
            )}
            {buttonTextSecond && (
              <button
                className={this.btnClass('second')}
                disabled={choice !== undefined}
                onClick={this.handleSecond}
              >
                {buttonTextSecond}
              </button>
            )}
          </div>
        </div>
        {choice && choice === 'first' && (
          <div className="scenario__result">
            <p className="scenario__result-text">{resultTextFirst}</p>
            <span className="scenario__result-score">{scoreFirst} punten</span>
          </div>
        )}
        {choice && choice === 'second' && (
          <div className="scenario__result">
            <p className="scenario__result-text">{resultTextSecond}</p>
            <span className="scenario__result-score">{scoreSecond} punten</span>
          </div>
        )}
      </div>
    );
  }
}

Scenario.propTypes = {
  id: PropTypes.string.isRequired,
  image: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  scoreFirst: PropTypes.number.isRequired,
  scoreSecond: PropTypes.number.isRequired,
  buttonTextFirst: PropTypes.string.isRequired,
  buttonTextSecond: PropTypes.string.isRequired,
  resultTextFirst: PropTypes.string.isRequired,
  resultTextSecond: PropTypes.string.isRequired,
  updateScenario: PropTypes.func.isRequired,
  choice: PropTypes.oneOf(['first', 'second']),
  onCallback: PropTypes.func,
};

Scenario.defaultProps = {
  onCallback: () => {},
  choice: undefined,
};

export default connect(mapStateToProps, { updateScenario })(Scenario);



// WEBPACK FOOTER //
// ./src/components/Scenario/index.js